<app-collar-map></app-collar-map>

<app-device-errors></app-device-errors>

<app-firmware-stats></app-firmware-stats>
